export class DimgDeleteDocumentsJob {
  applicationId: string;
  documentNames: string[];
}
